import { render, staticRenderFns } from "./quick-start.page.vue?vue&type=template&id=06280677&scoped=true"
import script from "./quick-start.page.vue?vue&type=script&lang=js"
export * from "./quick-start.page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06280677",
  null
  
)

export default component.exports